// extracted by mini-css-extract-plugin
export default {"video-container":"tutorial_video-container__kfe01","video":"tutorial_video__3bOlh","video-title":"tutorial_video-title__lBI22"};